import { MOUNTS } from '@nine/shared';
import { cloud, figure, sprite, sword } from '../kit';
import { C } from '../pix';
import { defineIconKind, registerIcons } from '../store';

/** Mounts (พาหนะ): sky tiles with the mount in flight. */

defineIconKind('mount', {
  label: 'พาหนะ',
  ids: () => Object.keys(MOUNTS),
  name: (id) => MOUNTS[id]?.name ?? id,
  tint: () => '#5ab0e8',
  plate: 'square',
  fallback: () => ({ draw: (p) => cloud(p, 5, 24, 22, C.white) }),
});

registerIcons('mount', {
  'flying-sword': (p) => {
    for (let x = 4; x < 26; x += 3) p.px(x, 25 + (x % 2), '#c8f0ff');
    sword(p, 3, 21, 29, 19, { hilt: C.gold, w: 2.6 });
    figure(p, 12, 8, C.white, 'stand', { head: C.skin });
  },
  eagle: (p) => {
    sprite(
      p,
      2,
      6,
      [
        'ww....................ww',
        '.www................www.',
        '..wwww....hh.....wwww..',
        '...wwwwwwwhhywwwwwww....',
        '....wwwwwbbbbwwwwww.....',
        '.......wwbbbbbww........',
        '.........bbbbb..........',
        '.........t.t.t..........',
      ],
      { w: '#6a4a2a', h: C.white, y: '#f0c040', b: '#8a6a4a', t: '#f0c040' },
    );
    cloud(p, 6, 28, 20, C.white);
  },
  // The title's black eagle (เถาฉางเยี่ย only): the same bird in ink, with a seal-red eye.
  'black-eagle': (p) => {
    sprite(
      p,
      2,
      6,
      [
        'ww....................ww',
        '.www................www.',
        '..wwww....hh.....wwww..',
        '...wwwwwwwhhywwwwwww....',
        '....wwwwwbbbbwwwwww.....',
        '.......wwbbbbbww........',
        '.........bbbbb..........',
        '.........t.t.t..........',
      ],
      { w: '#22222e', h: '#3a3a48', y: '#b3261c', b: '#16161e', t: '#c8a030' },
    );
    cloud(p, 6, 28, 20, C.white);
  },
});
